import { AnyAction, createReducer } from '@reduxjs/toolkit';
import {
	FacilityStoreState,
	SensorIdMap,
} from '../../features/AssetGrid/types/facility.types';
import {
	clearFacilities,
	clearSensorIdsMap,
	getFacilityResolved,
	setSensorIdsMap,
} from './actions';

export const initialState: FacilityStoreState = {
	facilitiesList: {},
	sensorIdsMap: {},
};

interface FacilityReducer {
	[x: string]: (
		state: FacilityStoreState,
		action: AnyAction,
	) => FacilityStoreState | undefined;
}

const reducer: FacilityReducer = {
	[getFacilityResolved.toString()]: (state, action) => ({
		...state,
		facilitiesList: {
			...state.facilitiesList,
			[action.payload.facilityId]: action.payload.facilityItem,
		},
	}),
	[clearFacilities.toString()]: state => ({
		...state,
		facilitiesList: {},
	}),
	[setSensorIdsMap.toString()]: (state, action) => ({
		...state,
		sensorIdsMap: action.payload.reduce(
			(map: Record<string, SensorIdMap>, item: SensorIdMap) => {
				const id = item.sensorId;
				map[id] = {
					sensorId: item.sensorId,
					sensorAlias: item.sensorAlias,
				};
				return map;
			},
			{},
		),
	}),
	[clearSensorIdsMap.toString()]: state => ({
		...state,
		sensorIdsMap: {},
	}),
};

export default createReducer(initialState, reducer);
